import { CheckCircleIcon, InfoCircleIcon, TimesCircleIcon } from '@wkda/icons';
import cx from 'classnames';
import type { ReactNode } from 'react';

export interface AlertBoxProps {
  children?: ReactNode;
  variant?: 'success' | 'error' | 'info';
  design?: 'simple' | 'complete';
  className?: string;
}

export default function AlertBox({
  children,
  variant,
  className,
  design = 'complete',
}: AlertBoxProps) {
  const isSimple = design === 'simple';
  const isComplete = design === 'complete';
  const iconClassName = cx({
    'alert-box-simple__icon': isSimple,
    'alert-box-complete__icon': isComplete,
  });
  return (
    <div
      className={cx('alert-box d-flex relative align-items-center', className, {
        'alert-box-simple': isSimple,
        'alert-box-complete': isComplete,
        'alert-box-simple--success': isSimple && variant === 'success',
        'alert-box-simple--error': isSimple && variant === 'error',
        'alert-box-simple--info': isSimple && variant === 'info',
        'alert-box-complete--success': isComplete && variant === 'success',
        'alert-box-complete--error': isComplete && variant === 'error',
        'alert-box-complete--info': isComplete && variant === 'info',
      })}
    >
      <div className="alert-box__icon-container">
        {variant === 'success' && <CheckCircleIcon className={iconClassName} />}
        {variant === 'error' && <TimesCircleIcon className={iconClassName} />}
        {variant === 'info' && <InfoCircleIcon className={iconClassName} />}
      </div>
      <div
        className={cx({
          'alert-box-simple__content': isSimple,
          'alert-box-complete__content': isComplete,
        })}
      >
        {children}
      </div>
    </div>
  );
}
